import React from 'react'

import AssetsList from './AssetsList'
import AssetsLoader from '../_load/AssetsLoader'

const PageContent = () => {
  return (
    <AssetsLoader>
      <AssetsList />
    </AssetsLoader>
  )
}

export default PageContent
